import awsdk from 'awsdk';

// Waiting
// Started
// Ended
// Cancelled
// Disabled

export const ConferenceStatus = awsdk.AWSDKConferenceStatus;
export type ConferenceStatus = typeof ConferenceStatus;
